<mat-tab-group [selectedIndex]="0"
               class="a7-ui-auth-form_tab-group">
  <mat-tab>
    <a7-auth-form-tab formTitle="WE ARE SIGNING YOU OUT">
    </a7-auth-form-tab>
  </mat-tab>
</mat-tab-group>
